import { clearObject } from "@/functions/helpers.js";

export default {
  getAll(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/courses?${queryString}`)
        .then(response => {
          context.commit("setCourses", response.data.results);
          context.commit("setPagination", {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
            current: response.data.results.length
          });
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },
  getForMenu(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      window.axios
        .get(`/courses?${queryString}`)
        .then(response => {
          context.commit("setMenuCourses", response.data.results);
          context.commit("setMenuPagination", {
            count: response.data.count,
            next: response.data.next,
            previous: response.data.previous,
            current: response.data.results.length
          });
          resolve(response.data.results);
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/${id}`)
        .then(response => {
          context.commit("setCourse", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/students/progress", data)
        .then(resolve)
        .catch(reject);
    });
  },

  getLastLessons(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params || {}).toString();
      window.axios
        .get(`/students/last-lessons?${queryString}`)
        .then(response => {
          context.commit("setLastLessons", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getAllLessons(context, params) {
    const queryString = new URLSearchParams(params || {}).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/lessons?${queryString}`)
        .then(response => {
          context.commit("setLessons", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },

  getRecommendedOptions(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/recommended-options")
        .then(response => {
          context.commit("setRecommendedOptions", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getRecommendedHome(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/recommended-home")
        .then(response => {
          context.commit("setRecommendedHome", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getTrails(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/trails")
        .then(response => {
          context.commit("setTrails", response.data);
          resolve();
        })
        .catch(reject);
    });
  },

  getMentorship(context, params) {
    const queryString = new URLSearchParams(clearObject(params)).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/mentorship?${queryString}`)
        .then(response => {
          context.commit("setMentorship", response.data);
          resolve();
        })
        .catch(reject);
    });
  }
};
